import { useQuery } from '@tanstack/react-query';

import { getSubscriptionDetails, type GetSubscriptionDetailsParams } from './api';

export function useSubscriptionDetailsQuery(params: GetSubscriptionDetailsParams | undefined) {
  return useQuery({
    queryKey: ['subscription-details', params],
    queryFn: () => getSubscriptionDetails(params as GetSubscriptionDetailsParams),
    enabled: Boolean(params),
    staleTime: 30 * 1000,
  });
}
